<template>
  <div id="app" class="page" :class="[{'dimmed' : isDimmed}]">
      <router-view name="navigation" />
      <main class="site-main" :class="{'site-main--fullheight' : mobileSearchVisible && portableDevice}">
        <router-view />
      </main>
      <MALogin />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { checkUrl } from '@/utils/url-utils'
import eventBus from '@/utils/event-bus';
import MALogin from '@/components/MALogin.vue';
import { launchGTM } from '@/utils/tracking';
import { setPermanentData, getPermanentData } from '@/utils/browser-storage';

export default {
  name: 'App',
  components: {
    MALogin
  },
  computed: {
    ...mapGetters(['isDimmed', 'user', 'mobileSearchVisible', 'portableDevice', 'sessionData', 'appConfig'])
  },
  watch: {
      user(val) {
          if(!val) {
              this.$store.commit('setFavourites', []);
              this.$store.commit('setHome', false);
              this.$store.commit('setWork', false);
              this.$store.commit('setFavouritesLists', []);
              this.$store.commit('setSavedRoutes', false);
          }
      },
      sessionData(val) {
        if(val) {
            this.$store.dispatch('getAllFavourites');
            this.$store.dispatch('getSavedRoutes'); 
        }
      },
      $route(to, from) {
        eventBus.$emit('urlChanged', {to, from})
        // queries are different
        if(to.query !== from.query) {
          eventBus.$emit('urlQueryChanged', {to, from})
        }
      },
  },
  created() {
    this.checkCurrentUrl()
    this.checkAppConfig()
    this.loadGasStationOperators()
  },
  mounted() {
    // launchGTM('GTM-KV5XFPM') // already loaded in navigation with oeamtc tracking script
    launchGTM('GTM-TM2K358')
    this.checkForUserFirstVisit();
  },
  methods: {
    checkCurrentUrl() {
      checkUrl(this.$route)
    },
    async checkAppConfig() {

      await this.$store.dispatch('checkAppConfig')

      // process.env can only be used for static compile-time variables!
      // The fact 'isMAPage' is based on runtime information!
      // Also, in the future there is be the need to more runtime information, so it's
      // a good idea to prepare for that!
      // const isMAPage = process.env.VUE_APP_MODE && process.env.VUE_APP_MODE === 'MA'

      const isMAPage = this.appConfig.isMAPage

      console.info("process.env.VUE_APP_MODE ", process.env)
      console.info("appConfig ", this.appConfig);

      this.$store.commit('setMAPage', isMAPage)

      if(isMAPage) {
        this.initMALogin()
      }
    },
    async initMALogin() {
      await this.$store.dispatch('checkIfLoggedIn')
            
      if(!this.user) {
        await this.$store.dispatch('loginWithNTLM')
        if(!this.user) {
          setTimeout(() => {
            eventBus.$emit('showMALoginOverlay')
          }, 100);
        }
      } else {
        this.$router.push({name: 'Main'})
      }
    },
    checkForUserFirstVisit() {
      const permissionChecked = getPermanentData('returning-visitor');
      if (!permissionChecked) {
          setPermanentData('returning-visitor', true);
          eventBus.$emit('showFeatureIntroduction');
      }
    },
    async loadGasStationOperators() {
        await this.$store.dispatch('loadGasStationsOperatorList')
    }
  }
}
</script>

<style lang="scss">
.page {
  &:after {
    content: '';
    @include fillout;
    background: rgba($color-black, 0.2);
    z-index: 120;
    transition: opacity 300ms $ease-out-quad;
    opacity: 0;
    pointer-events: none;
  }

  &.dimmed {
    position: relative;
    &:after {
      z-index: 5000;
      opacity: 1;
      pointer-events: auto;
    }
  }
}

.site-main {
  height: calc(#{$fullheight} - #{$nav-height});
  overflow: hidden;
  position: relative;

  &--fullheight {
      height: 100vh;
  }
}
</style>